/* eslint-disable max-len */
const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;

  return {
    sheetContainer: {
      // background: theme.backgroundColor,
      // borderRadius: '15px 15px 0 0',
    },
    sheetHeader: {
      background: theme.backgroundColor,
      borderRadius: '15px 15px 0 0',
    },
    sheetContent: {
      background: theme.backgroundColor,
    },
    title: {
      margin: [10, 0, 20],
      fontSize: 16,
      fontWeight: '700',
    },
    content: {
      color: '#B0B0B0', // Light gray color
      fontSize: '14px', // Adjust as needed for readability
      textAlign: 'center', // Center the text if needed
      marginTop: '8px', // Adjust spacing as needed
    },
    divider: {
      '&.ant-divider-horizontal.ant-divider-with-text': {
        color: theme.textColor,
        opacity: 0.5,
        fontWeight: '400',
        fontSize: 12,
        borderTopColor: 'rgb(255 255 255 / 10%)',
        marginTop: 0,
      },
    },
    thirdPartyButton: {
      width: '100%',
      color: theme.textColor,
      fontSize: 14,
      fontWeight: 400,
      height: 50,
      border: 'none',
      borderRadius: 10,
      borderTopRightRadius: 10,
      borderTopLeftRadius: 10,
      // borderBottom: '1px solid rgba(255, 255, 255, 0.10)',
      background: 'rgba(255, 255, 255, 0.10)',
      '&.ant-btn': {
        '&:hover, &:focus, &:active, &[disabled]': {
          border: 'none',
          background: 'rgba(255, 255, 255, 0.10)',
          '&:before': {
            opacity: 0.2,
            backgroundColor: 'rgb(255, 255, 255)',
            content: '""',
          },
          '&:not(.ant-btn-loading):active:before': {
            opacity: 0.3,
            backgroundColor: 'rgb(0, 0, 0)',
          },
        },
      },

      '&:first-of-type': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderBottom: '1px solid rgba(255, 255, 255, 0.10)',
      },
      '&:last-of-type': {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      },
    },
    fullScreenLoading: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      zIndex: 9999,
      flexDirection: 'column',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
